const STEPS = [
  { label: 'Jadwal',  n: 1 },
  { label: 'Pesanan', n: 2 },
  { label: 'Review',  n: 3 },
  { label: 'Bayar',   n: 4 },
  { label: 'Selesai', n: 5 },
] as const;

interface Props {
  current: 1 | 2 | 3 | 4 | 5;
}

export function StepBar({ current }: Props) {
  return (
    <div
      className="sticky top-0 z-50 border-b px-4 py-3"
      style={{ background: 'var(--surface)', borderColor: 'var(--border)' }}
    >
      <div className="mx-auto flex max-w-md items-center">
        {STEPS.map(({ label, n }, i) => {
          const done   = n < current;
          const active = n === current;
          return (
            <div key={n} className="flex flex-1 flex-col items-center gap-1">
              {/* connector + node row */}
              <div className="flex w-full items-center">
                {/* left line */}
                {i > 0 && (
                  <div
                    className="h-px flex-1 transition-colors"
                    style={{ background: n <= current ? 'var(--pink)' : 'rgba(255,255,255,0.1)' }}
                  />
                )}

                {/* node */}
                <div
                  className={[
                    'flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold transition-all',
                    done   ? 'text-white' : '',
                    active ? 'border-2 text-white' : '',
                    !done && !active ? 'bg-white/10 text-white/30' : '',
                  ].join(' ')}
                  style={
                    done   ? { background: 'var(--pink)' } :
                    active ? { borderColor: 'var(--pink)' } :
                    undefined
                  }
                >
                  {done ? '✓' : n}
                </div>

                {/* right line */}
                {i < 4 && (
                  <div
                    className="h-px flex-1 transition-colors"
                    style={{ background: n < current ? 'var(--pink)' : 'rgba(255,255,255,0.1)' }}
                  />
                )}
              </div>

              {/* label */}
              <span
                className="text-[9px] transition-colors"
                style={{ color: active ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)' }}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
